<div [hidden]="outageMessage === null">
  <div class="outage-bar">
    <div class="outage-icon"><i class='csx-common_stop'></i></div>
    <div class="outage-message"><span>{{outageMessage}}</span></div>
  </div>
</div>
